import React, { useState, useEffect, useContext, Component, useRef } from "react";
import AsyncBoard from "react-trello";
import Board from "react-trello";
import RealtimeBoard from "react-trello";
import ReactBSAlert from "react-bootstrap-sweetalert";
import EmpresaContext from "../../../contexts/Empresa";
import api from "../../../services/api";
import { DivCard, KanbanGlobalStyle } from "./styles";
import AuthContext from "../../../contexts/Auth";

import {
  Spinner,
  Badge,
  Progress,
  Dropdown,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  Button,
  FormGroup,
} from "reactstrap";
import Select2 from "react-select2-wrapper";
import Avatar from "../../../components/Avatar";

export default ({
  lanes,
  onChangeEstagioExterno,
  onChangeMotivoEncerramentoExterno,
  handleLoadMoreCards,
  lastSearch,
  pageProperties,
  notify,
  loading,
  readOnly,
  onOpenChatModal,
  onOpenCopilot,
  onCriarCard,
  onVerCards,
  onVerOportunidade,
  hasPipeline = false,
  ...props
}) => {
  const { empresaSelecionada, parametrosEmpresa } = useContext(EmpresaContext);
  const [alert, setAlert] = useState(null);
  const [alertCrossSelling, setAlertCrossSelling] = useState(null);

  const parametroComentario = parametrosEmpresa?.avancar_oportunidade_comentario === "true";
  const [comentarioEstagio, setComentarioEstagio] = useState("");
  const [pendingMovimento, setPendingMovimento] = useState(null);
  const [showAlertEstagio, setShowAlertEstagio] = useState(false);

  const [oportunidadeId, setOportunidadeId] = useState(undefined);
  const [listaOportunidades, setListaOportunidades] = useState({ lanes: [] });
  const [eventBus, setEventBus] = useState();

  const [runRefresh, setRunRefresh] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const { user } = useContext(AuthContext);

  const boardWrapperRef = useRef(null);
  const stickyScrollRef = useRef(null);
  const stickyScrollInnerRef = useRef(null);
  const isSyncingFromBoard = useRef(false);
  const isSyncingFromSticky = useRef(false);

  useEffect(() => {
    // O BoardWrapper do react-trello é sempre o firstElementChild.
    // Tem overflow-y: hidden que implicitamente habilita overflow-x: auto no browser.
    const timeout = setTimeout(() => {
      const boardEl = boardWrapperRef.current?.firstElementChild;
      if (!boardEl || !stickyScrollRef.current || !stickyScrollInnerRef.current) return;

      const updateWidth = () => {
        if (!stickyScrollRef.current || !stickyScrollInnerRef.current) return;
        // Equaliza os ranges de scroll: o espelho ocupa a tela toda (inclui sidebar),
        // mas o board começa depois da sidebar. A fórmula garante que os maxScrollLeft sejam iguais.
        const boardScrollRange = boardEl.scrollWidth - boardEl.clientWidth;
        stickyScrollInnerRef.current.style.width =
          (boardScrollRange + stickyScrollRef.current.clientWidth) + "px";
      };

      const onBoardScroll = () => {
        if (isSyncingFromSticky.current) return;
        isSyncingFromBoard.current = true;
        stickyScrollRef.current.scrollLeft = boardEl.scrollLeft;
        isSyncingFromBoard.current = false;
      };

      const onStickyScroll = () => {
        if (isSyncingFromBoard.current) return;
        isSyncingFromSticky.current = true;
        boardEl.scrollLeft = stickyScrollRef.current.scrollLeft;
        isSyncingFromSticky.current = false;
      };

      updateWidth();
      boardEl.addEventListener("scroll", onBoardScroll);
      stickyScrollRef.current.addEventListener("scroll", onStickyScroll);

      const observer = new ResizeObserver(updateWidth);
      observer.observe(boardEl);

      const stickyEl = stickyScrollRef.current;
      return () => {
        boardEl.removeEventListener("scroll", onBoardScroll);
        stickyEl.removeEventListener("scroll", onStickyScroll);
        observer.disconnect();
      };
    }, 400);

    return () => clearTimeout(timeout);
  }, [lanes]);

  function handleChangeStatusInKanban(op, newStatus) {
    if (newStatus === 'Aberta' && (op.data_encerramento || op.data_conversao)) {
      if (op.data_conversao) {
        setAlert(
          <ReactBSAlert
              warning
              title="Desfazer conversão?"
              onConfirm={() => executeDesfazerConversao(op)}
              onCancel={() => setAlert(null)}
              showCancel
              confirmBtnBsStyle="primary"
              confirmBtnText="Sim"
              cancelBtnBsStyle="link"
              cancelBtnText="Não"
              btnSize=""
          />
        );
      } else {
        setAlert(
            <ReactBSAlert
                warning
                title="Restaurar oportunidade?"
                onConfirm={() => executeRestaurar(op)}
                onCancel={() => setAlert(null)}
                showCancel
                confirmBtnBsStyle="primary"
                confirmBtnText="Sim"
                cancelBtnBsStyle="link"
                cancelBtnText="Não"
                btnSize=""
            />
        );
      }
    } else if (newStatus === 'Convertida' && !op.data_conversao) {
      if (props.onOpenConverterModal) props.onOpenConverterModal(op);
    } else if (newStatus === 'Perdida' && !op.data_encerramento) {
      if (props.onOpenEncerrarModal) props.onOpenEncerrarModal(op);
    }
  }

  async function executeRestaurar(op) {
    try {
      setAlert(null);
      await api.patch(`/common/empresas/${empresaSelecionada?.id}/oportunidades/${op.id}/restaurar-oportunidades`);
      if (notify) notify("success", "Oportunidade restaurada");
      if (onChangeEstagioExterno) onChangeEstagioExterno();
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível restaurar oportunidade");
    }
  }

  async function executeDesfazerConversao(op) {
    try {
      setAlert(null);
      await api.put(`/marketing/oportunidades/${op.id}/desfazer-conversao`, {
        user_id: empresaSelecionada?.id,
      });
      if (notify) notify("success", "Conversão desfeita com sucesso");
      if (onChangeEstagioExterno) onChangeEstagioExterno();
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível desfazer a conversão");
    }
  }

  const successAlert = (msg) => {
    setAlert(
      <ReactBSAlert
        success
        style={{ display: "block", marginTop: "-100px", maxWidth: "500px" }}
        title={msg}
        confirmBtnBsStyle="success"
        showConfirm={false}
        btnSize=""
      />,
    );
    setTimeout(() => setAlert(null), 2000);
  };

  const confirmAlertUpdateFase = (
    title,
    msg,
    confirmFunction,
    cancelFunction,
    confirmButtonLabel = "Ok",
    confirmButtonColor = "primary",
  ) => {
    setAlert(
      <ReactBSAlert
        warning
        closeOnClickOutside={false}
        title={title}
        onCancel={cancelFunction}
        onConfirm={confirmFunction}
        showCancel
        confirmBtnColor={confirmButtonColor}
        confirmBtnText={confirmButtonLabel}
        cancelBtnText="Cancelar"
        btnSize=""
      >
        {msg}
      </ReactBSAlert>,
    );
  };

  const confirmAlertCrossSelling = (
    title,
    msg,
    confirmFunction,
    confirmButtonLabel = "Ok",
    confirmButtonColor = "primary",
  ) => {
    setAlertCrossSelling(
      <ReactBSAlert
        warning
        closeOnClickOutside={false}
        title={title}
        onCancel={() => setAlertCrossSelling(null)}
        onConfirm={confirmFunction}
        showCancel
        confirmBtnColor={confirmButtonColor}
        confirmBtnText={confirmButtonLabel}
        cancelBtnText="Não"
        btnSize=""
      >
        {msg}
      </ReactBSAlert>,
    );
  };

  function onChangeEstagio(oportunidadeId, proximoEstagio) {
    if (parametroComentario) {
      setComentarioEstagio("");
      setPendingMovimento({ oportunidadeId, proximoEstagio });
      setShowAlertEstagio(true);
    } else {
      confirmAlertUpdateFase(
        "Alterar estágio",
        <>Deseja realmente alterar o estágio dessa oportunidade?</>,
        () => changeToEstagio(oportunidadeId, proximoEstagio),
        () => cancelChangeEstagio(),
        "Sim",
      );
    }
  }

  function cancelChangeEstagio() {
    setAlert(null);
    onChangeEstagioExterno();
  }

  async function changeToEstagio(oportunidadeId, nextEstagio, comentario = "") {
    const nextEstagioId = nextEstagio?.id ?? nextEstagio;
    const flagConversao = nextEstagio?.flag_conversao;
    try {
      if (flagConversao) {
        await api.put(
          `/marketing/oportunidades/${oportunidadeId}/converter`,
          { user_id: empresaSelecionada?.id },
        );
      } else {
        await api.put(
          `/common/empresas/${empresaSelecionada?.id}/oportunidades/${oportunidadeId}/avancar-oportunidades`,
          { estagio_id: nextEstagioId },
        );
      }

      if (comentario && comentario.trim()) {
        try {
          await api.post(
            `/common/empresas/${empresaSelecionada?.id}/oportunidades/${oportunidadeId}/comentarios`,
            { descricao: comentario.trim() }
          );
        } catch (comentarioError) {
          console.log(comentarioError);
          if (notify) notify("danger", "Estágio alterado, mas não foi possível salvar o comentário.");
        }
      }

      if (onChangeEstagioExterno) onChangeEstagioExterno();

      successAlert("Estágio alterado");
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível alterar estagio");
    }
  }

  async function thisOportunidadeContemProdutosDeclinados(oportunidadeId) {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/oportunidades/${oportunidadeId}/produtos_declinados`,
      );
      var prodDeclidados = response.data;
      var hasProdutosDeclinados = prodDeclidados && prodDeclidados.length > 0;
      return hasProdutosDeclinados;
    } catch (error) {
      notify("danger", "Não foi possivel carregar produtos declinados");
      return false;
    }
  }

  function onChangeEstagioToVenda(oportunidadeId) {
    confirmAlertCrossSelling(
      "Criar Cross-Selling",
      <>
        Deseja criar uma nova oportunidade a partir dos produtos declinados
        desta oportunidade encerrada?
      </>,
      () => criarNovaOportunidadeCrossSelling(oportunidadeId),
      "Sim",
    );
  }

  function goToNewCrossSelling(oportunidadeId) {
    props.history.push("/admin/oportunidades/new", {
      oportunidadeToCrossSelling: oportunidadeId,
      tipoCrossSelling: "produtos_declinados",
    });
  }

  async function criarNovaOportunidadeCrossSelling(oportunidadeId) {
    try {
      goToNewCrossSelling(oportunidadeId);
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível abrir nova oportunidade");
    }
  }

  const shouldReceiveNewData = (nextData) => {
    // console.log('OnDataChange')
    // console.log('New card has been added')
    // console.log(nextData)
  };

  const handleCardAdd = (card, laneId) => {
    // console.log(`New card added to lane ${laneId}`)
    // console.dir(card)
  };

  const handleCardClick = (oportunidadeId) => {
    // console.log(`CLICOU NO CARD`)
    // console.log(oportunidadeId)
    onVerOportunidade && onVerOportunidade({ id: oportunidadeId });
  };

  async function handleLaneScroll(requestedPage, laneId) {
    // console.log(`SCROLL INFINITO`)
    // console.log(requestedPage)
    // console.log(laneId)

    return await handleLoadMoreCards(
      requestedPage,
      10,
      "data_agendamento",
      "desc",
      lastSearch,
      laneId,
    );
  }

  function goToEdit(id) {
    props.history.push(`/admin/oportunidades/${new Number(id)}/edit`);
  }

  const handleDragStart = (cardId, laneId) => {
    setIsDragging(true);
    // console.log('drag started')
    // console.log(`cardId: ${cardId}`)
    // console.log(`laneId: ${laneId}`)
  };

  const handleDragEnd = (cardId, sourceLaneId, targetLaneId) => {
    setIsDragging(false);
    // console.log('drag ended')
    // console.log(`cardId: ${cardId}`)
    // console.log(`sourceLaneId: ${sourceLaneId}`)
    // console.log(`targetLaneId: ${targetLaneId}`)

    if (sourceLaneId != targetLaneId) {
      let draggedCard = null;
      for (const lane of lanes) {
        draggedCard = lane.cards.find((c) => String(c.id) === String(cardId));
        if (draggedCard) break;
      }

      if (draggedCard && draggedCard.data_encerramento) {
        notify(
          "danger",
          "Esta oportunidade está marcada como perdida. Para continuar a negociação, primeiro restaure a oportunidade.",
        );
        if (onChangeEstagioExterno) onChangeEstagioExterno();
        return;
      }

      const targetLane = lanes.find((l) => String(l.id) === String(targetLaneId));
      onChangeEstagio(cardId, targetLane || targetLaneId);
    }
  };

  const CustomLaneHeader = ({ title, barColor }) => {
    return (
      <div
        style={{
          boxShadow: "none", // Remove a sombra
          border: "none", // Remove a borda
          backgroundColor: "transparent",
          padding: "10px",
        }}
      >
        <div
          style={{
            height: 5,
            marginBottom: 5,
            backgroundColor: barColor,
            borderRadius: 3,
          }}
        ></div>

        <header
          style={{
            paddingBottom: 6,
            marginBottom: 10,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            fontSize: 14,
            fontWeight: "bold",
          }}
        >
          {title}
        </header>
      </div>
    );
  };

  const CustomCard = (props) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);

    return (
      <DivCard {...props} cardColor={props.cardColor} draggable={props.cardDraggable}>
        <header
          style={{
            borderBottom: "1px solid #eee",
            paddingBottom: 6,
            marginBottom: 10,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            color: props.cardColor,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "2px",
              minWidth: 0,
              flex: 1,
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: "bold",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {props.title}
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                fontSize: 12,
                color: "#666",
                fontWeight: "500",
              }}
            >
              <i className="fas fa-phone" style={{ fontSize: "11px", color: "#25D366" }}></i>
              {props.telefone}
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            {dropdownOpen && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0, 0, 0, 0.4)",
                  zIndex: 1040,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDropdown();
                }}
              />
            )}

            <button
              onClick={(e) => {
                e.stopPropagation();
                onOpenCopilot && onOpenCopilot(props);
              }}
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                padding: "2px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="Copiloto Insights"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 36 36"
                fill="none"
              >
                <defs>
                  <linearGradient id="sparkleGrad" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor="#11CDEF" />
                    <stop offset="100%" stopColor="#11CDEF" />
                  </linearGradient>
                </defs>
                <path
                  d="M13 0C13 0 13 8 7.5 10.5C2 13 0 13 0 13C0 13 8 13 10.5 18.5C13 24 13 26 13 26C13 26 13 18 18.5 15.5C24 13 26 13 26 13C26 13 18 13 15.5 7.5C13 2 13 0 13 0Z"
                  fill="url(#sparkleGrad)"
                />
                <path
                  d="M28 18C28 18 28 21.5 25.5 22.5C23 23.5 22 23 22 23C22 23 25.5 23 26.5 25.5C27.5 28 28 29 28 29C28 29 28 25.5 30.5 24.5C33 23.5 34 23 34 23C34 23 30.5 23 29.5 20.5C28.5 18 28 18 28 18Z"
                  fill="url(#sparkleGrad)"
                />
              </svg>
            </button>

            <button
              onClick={(e) => {
                e.stopPropagation();
                onOpenChatModal && onOpenChatModal(props);
              }}
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
              }}
              title="Abrir WhatsApp"
            >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 32 32"
              fill="currentColor"
            >
              <path
                fill="#25D366"
                d="M16 .395C7.162.395.011 7.546.011 16.384c0 2.887.756 5.678 2.194 8.145L.01 32l7.686-2.164a15.924 15.924 0 0 0 8.305 2.272h.001c8.838 0 15.989-7.151 15.989-15.989 0-8.838-7.151-15.989-15.989-15.989zm0 29.224a13.2 13.2 0 0 1-6.736-1.848l-.484-.287-4.56 1.284 1.308-4.445-.315-.456a13.198 13.198 0 0 1-2.022-7.249c0-7.314 5.95-13.264 13.265-13.264 3.547 0 6.877 1.381 9.384 3.889 2.508 2.507 3.89 5.837 3.89 9.385 0 7.314-5.95 13.264-13.265 13.264zm7.264-9.949c-.396-.198-2.343-1.156-2.707-1.287-.364-.133-.629-.198-.895.198-.266.396-1.028 1.287-1.26 1.553-.232.264-.463.297-.86.099-.396-.198-1.67-.615-3.182-1.961-1.176-1.05-1.97-2.344-2.202-2.74-.231-.396-.025-.609.173-.807.178-.177.396-.463.595-.694.198-.231.264-.396.396-.662.132-.265.066-.497-.033-.695-.099-.198-.895-2.156-1.228-2.951-.323-.776-.651-.67-.895-.682-.231-.012-.496-.015-.761-.015s-.694.099-1.06.497c-.364.396-1.39 1.356-1.39 3.308s1.423 3.842 1.623 4.106c.198.265 2.799 4.27 6.787 5.98.949.41 1.689.653 2.265.835.951.302 1.819.259 2.505.157.764-.115 2.343-.958 2.674-1.881.33-.923.33-1.713.232-1.88-.099-.165-.364-.264-.76-.462z"
              />
            </svg>
            </button>

            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggleDropdown}
              onClick={(e) => e.stopPropagation()}
              onMouseDown={(e) => e.stopPropagation()}
              style={{ position: "relative", zIndex: dropdownOpen ? 1041 : "auto" }}
            >
              <DropdownToggle
                tag="button"
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "2px 6px",
                  color: "#8898aa",
                  fontSize: "16px",
                  lineHeight: 1,
                }}
              >
                <i className="fas fa-ellipsis-v" />
              </DropdownToggle>
              <DropdownMenu strategy="fixed" positionFixed={true} modifiers={{ flip: { enabled: false }, preventOverflow: { boundariesElement: 'viewport' } }}>
                <DropdownItem
                  onClick={(e) => {
                    e.stopPropagation();
                    goToEdit(props.id);
                  }}
                >
                  <i className="fas fa-eye mr-2" />
                  Ver oportunidade
                </DropdownItem>
                {hasPipeline && (
                  <DropdownItem
                    onClick={(e) => {
                      e.stopPropagation();
                      onCriarCard && onCriarCard(props);
                    }}
                  >
                    <i className="fas fa-columns mr-2" />
                    Criar card no pipeline
                  </DropdownItem>
                )}
                {hasPipeline && (
                  <DropdownItem
                    onClick={(e) => {
                      e.stopPropagation();
                      onVerCards && onVerCards(props);
                    }}
                  >
                    <i className="fas fa-list mr-2" />
                    Ver cards vinculados
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
          </div>
        </header>

        <div
          style={{
            fontSize: 14,
            color: "#4C4C4C",
            display: "flex",
            flexDirection: "column",
            padding: ".5rem",
            gap: ".5rem",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {props.subTitle}
          </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                  color: "#666",
                }}
              >
                <div
                  style={{
                    width: "25px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <i className="fas fa-clock" style={{ fontSize: "16px" }}></i>
                </div>
                <span style={{ marginLeft: "5px" }}>
                  {props.data_agendamento}
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                  color: "#666",
                }}
              >
                <div
                  style={{
                    width: "25px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <i
                    className="far fa-calendar-alt"
                    style={{ fontSize: "16px" }}
                  ></i>
                </div>
                <span style={{ marginLeft: "5px" }}>{props.data_cadastro}</span>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                  color: "#666",
                }}
              >
                <div
                  style={{
                    width: "25px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <i
                    className="fas fa-dollar-sign"
                    style={{ fontSize: "16px" }}
                  ></i>
                </div>
                <span style={{ marginLeft: "5px" }}>{props.valor}</span>
              </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "12px",
                color: "#6c757d",
                width: "100%",
              }}
            >
              {/* Lado esquerdo: ícone + texto */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <i
                  className="fas fa-bullhorn"
                  style={{ fontSize: "14px", marginLeft: "5px" }}
                ></i>

                <span
                  style={{
                    fontWeight: "500",
                    whiteSpace: "nowrap",
                  }}
                >
                  {props.anuncio.slice(0,35)} {props.anuncio.length > 35 ? "..." : ""}
                </span>
              </div>

              {/* Lado direito: avatar */}
              <Avatar
                style={{
                  width: "25px",
                  height: "25px",
                  minWidth: "25px",
                  fontSize: "10px",
                }}
                user={props.colaborador}
              />
            </div>
          </div>

          <div
            style={{
              marginTop: 10,
              textAlign: "center",
              color: props.cardColor,
              fontSize: 15,
              fontWeight: "bold",
            }}
          >
            {props.escalationText}
          </div>
          <div
            style={{
              borderTop: "1px solid #eee",
              marginTop: "10px",
              paddingTop: "8px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
                maxHeight: "52px",
                overflow: "hidden",
                flex: 1,
              }}
            >
              <UncontrolledDropdown 
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} 
                onMouseDown={(e) => { e.stopPropagation(); }}
                onTouchStart={(e) => { e.stopPropagation(); }}
                direction="down"
              >
                <DropdownToggle
                  tag="span"
                  data-toggle="dropdown"
                  style={{ cursor: "pointer" }}
                >
                  <Badge
                    color={
                      props.data_encerramento
                        ? "danger"
                        : props.data_conversao
                        ? "success"
                        : "info"
                    }
                    pill
                    style={{
                      fontSize: "10px",
                      padding: "4px 8px",
                      textTransform: "uppercase",
                      lineHeight: "1.2",
                    }}
                  >
                    {props.data_encerramento
                      ? "Perdida "
                      : props.data_conversao
                      ? "Convertida "
                      : "Aberta "}
                    <i className="fas fa-caret-down"></i>
                  </Badge>
                </DropdownToggle>
                <DropdownMenu strategy="fixed" positionFixed={true}>
                  {(props.data_encerramento || props.data_conversao) && (
                    <DropdownItem onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleChangeStatusInKanban(props, 'Aberta'); }}>Aberta</DropdownItem>
                  )}
                  {!props.data_conversao && (
                    <DropdownItem onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleChangeStatusInKanban(props, 'Convertida'); }}>Convertida</DropdownItem>
                  )}
                  {!props.data_encerramento && (
                    <DropdownItem onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleChangeStatusInKanban(props, 'Perdida'); }}>Perdida</DropdownItem>
                  )}
                </DropdownMenu>
              </UncontrolledDropdown>
              {props.tags &&
                typeof props.tags === "string" &&
                props.tags
                  .split(",")
                  .filter((t) => t.trim() !== "")
                  .slice(0, 5)
                  .map((tag, index) => (
                    <Badge
                      key={`${props.id}-tag-${index}`}
                      color="secondary"
                      pill
                      style={{
                        fontSize: "10px",
                        padding: "4px 8px",
                        textTransform: "uppercase",
                        lineHeight: "1.2",
                      }}
                    >
                      {tag.trim()}
                    </Badge>
                  ))}
              {props.tags &&
                typeof props.tags === "string" &&
                props.tags.split(",").filter((t) => t.trim() !== "").length >
                  2 && (
                  <span
                    style={{
                      fontSize: "10px",
                      color: "#666",
                      alignSelf: "center",
                      fontWeight: "bold",
                    }}
                  >
                    
                  </span>
                )}
            </div>
          </div>
        </div>
      </DivCard>
    );
  };

  const components = {
    LaneHeader: CustomLaneHeader,
    Card: CustomCard,
  };

  return (
    <>
      <KanbanGlobalStyle />
      {alert}
      {alertCrossSelling}
      {showAlertEstagio && (
        <ReactBSAlert
          warning
          closeOnClickOutside={false}
          title="Alterar estágio"
          onCancel={() => {
            setShowAlertEstagio(false);
            setPendingMovimento(null);
            cancelChangeEstagio();
          }}
          onConfirm={() => {
            setShowAlertEstagio(false);
            const { oportunidadeId, proximoEstagio } = pendingMovimento;
            setPendingMovimento(null);
            changeToEstagio(oportunidadeId, proximoEstagio, comentarioEstagio);
          }}
          showCancel
          confirmBtnText="Confirmar"
          cancelBtnText="Cancelar"
          disabled={comentarioEstagio.trim().length < 15}
          btnSize=""
        >
          <FormGroup className="text-left mt-2">
            <label>
              Comentário <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              rows={3}
              placeholder="Adicione um comentário para avançar o estágio"
              value={comentarioEstagio}
              onChange={(e) => setComentarioEstagio(e.target.value)}
            />
            {comentarioEstagio.trim().length === 0 && (
              <small className="text-muted">O comentário é obrigatório para avançar o estágio.</small>
            )}
            {comentarioEstagio.trim().length > 0 && comentarioEstagio.trim().length < 15 && (
              <small className="text-danger">
                Mínimo 15 caracteres ({comentarioEstagio.trim().length}/15)
              </small>
            )}
          </FormGroup>
        </ReactBSAlert>
      )}

      <div
        ref={boardWrapperRef}
        className={`kanban-board-wrapper${isDragging ? " is-dragging" : ""}`}
      >
        <RealtimeBoard
          components={components}
          data={{ lanes }}
          onCardClick={handleCardClick}
          onCardAdd={handleCardAdd}
          onDataChange={shouldReceiveNewData}
          eventBusHandle={setEventBus}
          handleDragStart={handleDragStart}
          handleDragEnd={handleDragEnd}
          hideCardDeleteIcon={true}
          onLaneScroll={handleLaneScroll}
          laneStyle={{
            width: 400,
            minWidth: 400,
            backgroundColor: "#f4f7fa", 
            padding: "8px", 
            borderRadius: "8px",
            margin: "0 10px",
            minHeight: "75vh"
          }}
          style={{
            fontFamily: "inherit",
            backgroundColor: "#ffffff",
            height: "auto",
            paddingLeft: 0,
          }}
          tagStyle={{
            fontSize: "85%",
          }}
        />
      </div>

      {/* Scrollbar fixo na parte inferior da tela */}
      <div
        ref={stickyScrollRef}
        className="kanban-sticky-scrollbar"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          overflowX: "auto",
          overflowY: "hidden",
          height: "20px",
          zIndex: 1000,
          backgroundColor: "transparent",
        }}
      >
        <div ref={stickyScrollInnerRef} style={{ height: "1px" }} />
      </div>
    </>
  );
};
